import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProgressService {
  message = '';
  callbackRoute = '';
  status: Status;
  type: ProgressType;
  progressBar = new Subject();


  constructor() {
  }

  set(message, callback) {
    this.message = message;
    this.callbackRoute = callback;
  }

  reset() {
    this.message = '';
    this.callbackRoute = '';
  }
}

export enum ProgressType {
  UploadDataset,
  DownloadDataset
}

export enum Status {
  STARTED,
  FAILED,
  COMPLETED
}
